import { desktopTemplate } from '../template/DesktopTemplate'
import { mobileTemplate } from '../template/MobileTemplate'
import { langTemplate } from '../template/LangTemplate'
import { Lang } from '../entities/Lang'

class WidgetWrapper {
	container
	params
	languages

	setContainer (container) {
		this.container = container
		this.desktop = desktopTemplate
		this.mobile = mobileTemplate
		return this
	}

	setParams (params) {
		this.params = params
		this.languages = params.language.map(this._createLang.bind(this))
		return this
	}

	render () {
		let gtWidget = /* html */ `<div id="original-google-translate" class="d-none"></div>`
		this.container.innerHTML = gtWidget + this.desktop.getHtml(this.languages) + this.mobile.getHtml(this.languages)
	}
	
	_createLang (element) {
		const languages = new Lang()
		languages.name = element
		languages.template = langTemplate
		return languages
	}

}

const widgetWrapper = new WidgetWrapper()
export {
	WidgetWrapper,
	widgetWrapper
}



// WEBPACK FOOTER //
// ./templates/rekinysukcesu/js/extensions/mod_googletranslate/wrapper/WidgetWrapper.js